module.exports = "https://coinrabbit.io/_next/static/images/questions-a4bef390e6d6d0f1d53e716b6660e8e6.png";